import axios from '@/utils/axios';

 export const changeLeadStage = async (lead_id, stage_id) => {
  const response = await axios.patch(`/leads/${lead_id}/stage`, {
    lead_stage_id: stage_id
  });
  return response;
 };

export const exportLead = async ({
  format = 'csv', 
  ids = [], 
  from_date,
  to_date,
  user_id,
  branch_id,
  lead_stage_id,
  lead_source_id,
  conversion,
  search_keyword,
  setLoading = () => {}, 
  toastError = () => {}, 
  timeStamp = () => Date.now().toString()
 }) => {

 if(!from_date || from_date.trim() === '' || !to_date || to_date.trim() === ''){
  toastError('Please choose a date range.');
  return;
 }  


 setLoading(true);
 try{
   const payload = { 
     ids, 
     from_date, 
     to_date,
     user_id,
     branch_id,
     lead_stage_id,
     lead_source_id,
     conversion,
     search_keyword,
   };

    const response = await axios.post(`/leads/export/${format}`, payload, {
     responseType: 'blob',
    });

    const blob = new Blob([response.data], {
     type: response.headers['content-type'],
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);

    let filename = `leads_export_${timeStamp()}.${format}`;
    const disposition = response.headers['content-disposition'];

    if(disposition && disposition.indexOf('filename=') !== -1){
     const filenameMatch = disposition.match(/filename="?(.+)"?/);
     if(filenameMatch && filenameMatch.length === 2){
      filename = filenameMatch[1];
     }
    }

    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }catch(error){
   console.error(error);
   toastError(error?.message || 'Export failed');
  }finally{
   setLoading(false);
  }
 };